import React from 'react';
import * as ObjectHelper from 'js/common/object_helper';
import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';

const Phone = props => {
    const rowData = getRowDataForColumnComponent(props);
    return <div>{ObjectHelper.pathOr('', ['lead', 'user_profile', 'phone_number'], rowData)}</div>;
};

export default Phone;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/phone.js